import { Grid_Item_default } from "./chunk-LOW6ZCRQ.js";
import { Grid_default } from "./chunk-TY4EQ6BE.js";

// src/elements/Grid/index.ts
var GridComponent = Grid_default;
GridComponent.Item = Grid_Item_default;
GridComponent.Item.displayName = "Grid.Item";
export { GridComponent };